import { render, staticRenderFns } from "./OBJ.vue?vue&type=template&id=026f2fac&"
import script from "./OBJ.vue?vue&type=script&lang=js&"
export * from "./OBJ.vue?vue&type=script&lang=js&"
import style0 from "./OBJ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports